export const GET_CLASSIFICATIONS_LIST = "get_classification_list";
export const CREATE_CLASSIFICATION = "create_classification";
export const EDIT_CLASSIFICATION = "edit_classification";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const DELETE_CLASSIFICATION = "delete_classification";
export const ERROR = "error";
export const ACCESS_RIGHT_ERROR = "access_error";
